import { jsx as Q } from "react/jsx-runtime";
import { createContext as X, useState as e, useRef as C, useCallback as n, useEffect as Y } from "react";
import { resolveImageUrl as Z } from "./utils/imageProxy.js";
import { DEFAULT_THEME as $, applyThemeCssVars as tt } from "./utils/theme.js";
import { loadThemeFonts as S, applyThemeConfigColors as v } from "./utils/fontLoader.js";
import { extractWasAuthenticated as et } from "./utils/authSnapshot.js";
const ot = X(null);
function lt({ adapter: o, children: d }) {
  const [r, i] = e("native"), [a, g] = e(""), [x, P] = e($), [T, k] = e({
    token: null,
    status: "unknown"
  }), [A, u] = e(null), [I, l] = e(null), [E, U] = e(!1), [y, B] = e({ brandAppConfig: null, domainConfig: null }), [M, O] = e(""), [D, m] = e({}), [H, c] = e(null), [R, W] = e([]), [_, b] = e(""), [w, F] = e(!1), [j, f] = e(!1), [L, h] = e([]), s = C(o);
  s.current = o;
  const p = C("native"), V = n(
    (t) => {
      s.current.saveState(t);
    },
    []
  ), q = n(
    (t) => {
      s.current.sendCommand(t);
    },
    []
  );
  Y(() => (o.onInit((t) => {
    p.current = t.env, i(t.env), g(t.apiBaseUrl), P(t.theme), k(t.auth), u(t.savedState), l(t.themeConfig), U(t.editMode), B(t.ctx), O(t.urlSearchParams ?? ""), tt(t.theme), S(t.themeConfig), v(t.themeConfig);
  }), o.onData((t) => {
    m(t.toolInput), c(t.toolOutput), F(et(t.toolOutput, p.current)), W(t.dataParts ?? []), b(t.partState ?? ""), t.savedState && u(t.savedState);
  }), o.onStreamStart((t) => {
    m(t), f(!0), h([]);
  }), o.onStreamChunk((t, K) => {
    h((N) => [...N, t]), c(K);
  }), o.onStreamEnd((t) => {
    c(t), f(!1);
  }), o.onThemeConfig((t) => {
    l(t), S(t), v(t);
  }), o.connect(), () => {
    o.destroy();
  }), [o]);
  const z = n(
    (t) => Z(t, a, r),
    [a, r]
  ), G = n(
    (t) => {
      s.current.emitAction({ action: "product_click", payload: t });
    },
    []
  ), J = {
    env: r,
    theme: x,
    auth: T,
    apiBaseUrl: a,
    ctx: y,
    urlSearchParams: M,
    resolveImageUrl: z,
    trackProductClick: G,
    toolInput: D,
    toolOutput: H,
    dataParts: R,
    partState: _,
    sendCommand: q,
    savedState: A,
    saveState: V,
    wasAuthenticated: w,
    isStreaming: j,
    streamChunks: L,
    themeConfig: I,
    editMode: E,
    _adapter: s.current
  };
  return /* @__PURE__ */ Q(ot.Provider, { value: J, children: d });
}
export {
  lt as BridgeHostProvider,
  ot as WidgetHostCtx
};
